import { Drawer, Link } from '@one-thd/sui-atomic-components';
import React, { useEffect, useState } from 'react';
import { trackEditPickupLocationButtonDisplayed } from '../../../utils/edit-pickup-location/analytics';
import { EditPickupLocationDrawer } from './EditPickupLocationDrawer';
import { EditPickupLocationProvider } from '../../../contexts/EditPickupLocationContext';
export var EditPickupLocation = function () {
    var _a = useState(false), open = _a[0], setOpen = _a[1];
    var _b = useState(false), isOuterClick = _b[0], setIsOuterClick = _b[1];
    useEffect(function () {
        trackEditPickupLocationButtonDisplayed();
    }, []);
    return (React.createElement("div", { className: "card-fix" },
        React.createElement(Link, { component: "button", variant: "body-base", onClick: function () {
                setOpen(true);
            } }, "Edit"),
        open && (React.createElement(Drawer, { open: open, onClose: function () {
                setIsOuterClick(true);
            } },
            React.createElement(EditPickupLocationProvider, null,
                React.createElement(EditPickupLocationDrawer, { setOpen: setOpen, isOuterClick: isOuterClick, setIsOuterClick: setIsOuterClick }))))));
};
